import { canUseDOM } from "./dom";

export default () => {
  if (!canUseDOM()) return { x: 0, y: 0 };
  const x = window.pageXOffset || document.documentElement.scrollLeft;
  const y = window.pageYOffset || document.documentElement.scrollTop;
  return { x, y };
};
